const generalSettings = {
    aboutUsMRC: {
        min: 15,
        max: 1000
    },
    privacyPolicyMRC: {
        min: 100,
        max: 100000
    },
    returnPolicyMRC: {
        min: 100,
        max: 100000
    },
    cancellationPolicyMRC: {
        min: 50,
        max: 100000
    },
    faqMRC: {
        min: 50,
        max: 100000
    }
}

export default generalSettings;